module.exports = ".mat-select {\n  width: 100%;\n  margin-bottom: 20px;\n}\n"